import { Button } from "@mui/material";
import React from "react";

export function SaveAndCloseButton(props: { onClick: () => void }) {
  return (
    <Button variant={"contained"} onClick={props.onClick} style={{ minWidth: "10rem" }}>
      Save and Close
    </Button>
  );
}
